<div *ngIf="!isIMDevice && !deviceTypeService.isStudyDevice(device.config_info)" class="performance-values white-box main-black p-4 border-radius-bottom mb-2">
	<div class="preperty-values row" *ngIf="device.config_info">
		<div class="col-4 p-0" *ngIf="canAccessFirstGroup()">
			<div *ngIf="usersService.hasAccessPermission(enterprisePermissions, 'truck_id')">
				<div class="p-2">{{'devices.truck_id' | device_translation:deviceType}}</div>
				<div class="p-2">{{device.config_info.truck_id}}</div>
			</div>
			<div *ngIf="usersService.hasAccessPermission(enterprisePermissions, 'truck_type')">
				<div class="p-2">{{'devices.truck_type' | device_translation:deviceType}}</div>
				<div class="p-2">{{device.config_info.truck_type}}</div>
			</div>
			<div *ngIf="usersService.hasAccessPermission(enterprisePermissions, 'truck_sn')">
				<div class="p-2">{{ 'devices.truck_sn' | device_translation:deviceType}}</div>
				<div class="p-2">{{device.config_info.truck_sn}}</div>
			</div>
			<div *ngIf="usersService.hasAccessPermission(enterprisePermissions, 'battery_capacity') && !chargerDevicesTypes.includes(deviceType)">
				<div class="p-2">{{'devices.battery_capacity' | translate}}</div>
				<div class="p-2">{{device.config_info.battery_capacity}}</div>
			</div>
		</div>
		<div class="col-4">
			<div *ngIf="usersService.hasAccessPermission(enterprisePermissions, 'number_of_cells') && deviceVPC !== undefined">
				<div class="p-2">{{'rt.voltage' | translate}}</div>
				<div class="p-2" *ngIf="DeviceFactory.isChargerDeviceType(device.config_info.sct_device_type)">{{deviceCommonService.getChargerVoltageLabel(device.config_info.charger_voltage)}}</div>
				<div class="p-2" *ngIf="!DeviceFactory.isChargerDeviceType(device.config_info.sct_device_type)">{{device.config_info.number_of_cells * deviceVPC | number}}</div>
			</div>
			<div *ngIf="usersService.hasAccessPermission(enterprisePermissions, 'serial_number')">
				<div class="p-2">{{'g.iotah_sn' | device_translation:deviceType}}</div>
				<div class="p-2"><a [routerLink]="studyInfo.id && studyInfo.has_site_device_acces? ['/', studyInfo.device_customer_id, studyInfo.device_site_id, device.config_info.mac_address, 'performance'] : null">{{device.config_info.serial_number}}</a></div>
			</div>
			<div *ngIf="usersService.hasAccessPermission(enterprisePermissions, 'installation_date')">
				<div class="p-2">{{'devices.installation_date' | translate}}</div>
				<div class="p-2">{{commonService.isUnixZero(device.config_info.installation_date_fmt) ? '--/--/--' : device.config_info.installation_date_fmt}}</div>
			</div>
		</div>
		<div class="col-4">
			<div *ngIf="usersService.hasAccessFunction('shipment_management')">
				<div class="p-2">{{'g.purchase_order' | translate}}</div>
				<div class="p-2">{{device.config_info.po_number || '-'}}</div>
			</div>
			<div *ngIf="usersService.hasAccessFunction('shipment_management')">
				<div class="p-2">{{'ready_to_ship.shipping_date' | translate}}</div>
				<div class="p-2">{{ device.config_info.shipping_date }}</div>
			</div>
			<div *ngIf="usersService.hasAccessFunction('shipment_management')">
				<div class="p-2">{{'ready_to_ship.tracking_number' | translate}}</div>
				<div class="p-2">{{device.config_info.tracking_number || '-'}}</div>
			</div>
		</div>
	</div>
</div>

<div *ngIf="deviceTypeService.isStudyDevice(device.config_info) && studyInfo.id" class="performance-values white-box main-black p-4 border-radius-bottom mb-2">
	<div class="preperty-values row" *ngIf="device.config_info">
		<div class="col-4 p-0">
			<div>
				<div class="p-2">{{'devices.truck_id' | device_translation:deviceType}}</div>
				<div class="p-2">{{studyInfo.truck_id}}</div>
			</div>
			<div>
				<div class="p-2">{{'devices.truck_type' | device_translation:deviceType}}</div>
				<div class="p-2">{{studyInfo.truck_type}}</div>
			</div>
			<div>
				<div class="p-2">{{ 'devices.truck_sn' | device_translation:deviceType}}</div>
				<div class="p-2">{{studyInfo.truck_sn}}</div>
			</div>
		</div>

		<div class="col-4">
			<!-- <div>
				<div class="p-2">{{'device_performance.battery_id' | translate}}</div>
				<div class="p-2">{{device.battery_id}}</div>
			</div>
			<div>
				<div class="p-2">{{'battlinkDevice.devices.truck_type' | translate}}</div>
				<div class="p-2">{{device.battery_model}}</div>
			</div> -->
			<div>
				<div class="p-2">{{'devices.battery_capacity' | translate}}</div>
				<div class="p-2">{{studyInfo.battery_capacity}}</div>
			</div>
			<div>
				<div class="p-2">{{'battlinkDevice.devices.battery_voltage' | translate}}</div>
				<div class="p-2">{{studyInfo.nominal_battery_voltage}}</div>
			</div>
			<div>
				<div class="p-2">{{'g.iotah_ps_sn' | translate}}</div>
				<div class="p-2">{{studyInfo.serial_number}}</div>
			</div>
		</div>
	</div>
</div>

<div *ngIf="isIMDevice" class="performance-values white-box main-black p-4 border-radius-bottom mb-2">
	<div class="preperty-values row" *ngIf="device.config_info">
		<div class="col-4 p-0" *ngIf="canAccessFirstGroupIM()">
			<div
				*ngIf="usersService.hasAccessPermission(enterprisePermissions, 'serial_number', 'read', null, deviceConfig?.permissionMapperKey)">
				<div class="p-2">{{'g.iotah_sn' | device_translation:deviceType}}</div>
				<div class="p-2">{{device.config_info.serial_number}}</div>
			</div>
			<div
				*ngIf="usersService.hasAccessPermission(enterprisePermissions, 'installation_date', 'read', null, deviceConfig?.permissionMapperKey)">
				<div class="p-2">{{'devices.installation_date' | translate}}</div>
				<div class="p-2">{{commonService.isUnixZero(device.config_info.installation_date_fmt) ? '--/--/--' : device.config_info.installation_date_fmt}}</div>
			</div>
			<div
				*ngIf="usersService.hasAccessPermission(enterprisePermissions, 'power_view_sn', 'read', null, deviceConfig?.permissionMapperKey)">
				<div class="p-2">{{'devices.panel_id' | device_translation:deviceType}}</div>
				<div class="p-2">{{device.config_info.power_view_sn}}</div>
			</div>
		</div>
		<div class="col-4" *ngIf="canAccessSecGroupIM()">
			<div
				*ngIf="usersService.hasAccessPermission(enterprisePermissions, 'power_view_id', 'read', null, deviceConfig?.permissionMapperKey)">
				<div class="p-2">{{'devices.load_id' | device_translation:deviceType}}</div>
				<div class="p-2">{{device.config_info.power_view_id}}</div>
			</div>
			<div
				*ngIf="usersService.hasAccessPermission(enterprisePermissions, 'load_type', 'read', null, deviceConfig?.permissionMapperKey)">
				<div class="p-2">{{'devices.load_type' | device_translation:deviceType}}</div>
				<div class="p-2">{{device.config_info.load_type}}</div>
			</div>
		</div>
		<div class="col-4">
			<div *ngIf="usersService.hasAccessFunction('shipment_management')">
				<div class="p-2">{{'g.purchase_order' | translate}}</div>
				<div class="p-2">{{device.config_info.po_number || '-'}}</div>
			</div>
			<div *ngIf="usersService.hasAccessFunction('shipment_management')">
				<div class="p-2">{{'ready_to_ship.shipping_date' | translate}}</div>
				<div class="p-2">{{ device.config_info.shipping_date }}</div>
			</div>
			<div *ngIf="usersService.hasAccessFunction('shipment_management')">
				<div class="p-2">{{'ready_to_ship.tracking_number' | translate}}</div>
				<div class="p-2">{{device.config_info.tracking_number || '-'}}</div>
			</div>
		</div>
	</div>
</div>

<div *ngIf="!studyInfo.id" class="white-box main-black mt-4 p-4 border-radius mb-2">
	<div class="row p-1">
		<div class="col-sm-6 col-md-2">
			<h4>
				{{'site_performance.device_tags' | translate}}
				<app-help-tooltip *ngIf="tooltips.device_tags" [field]="tooltips.device_tags"></app-help-tooltip>
			</h4>
		</div>
		<div class="col-sm-6 col-md-8 ml-auto d-inline-flex"></div>
		<div class="col-sm-6 col-md-2 ml-auto d-inline-flex"></div>
		<div class="panel-body p-3 d-flex justify-content-between w-100">
			<app-tag-input
				[items]="device.tags.siteTagsValues"
				[deviceId]="device.mac_address"
				[tagInput]="device.tags.deviceTags[device.mac_address] || []"
				[siteId]="currentSite.id"
				[isSCTuser]="currentUser.isSCT"
			></app-tag-input>
		</div>
	</div>
</div>

<div class="white-box main-black mt-4 p-4 border-radius print-content"
	*ngIf="deviceConfig?.performance?.hasBatteryReport">
	<app-battery-report
		[device]="device"
		[currentSite]="currentSite"
		[allDailyDetails]="allDailyDetails"
		[utilizationScoreData]="utilizationScoreData"
		[printReportSummeryPeriodInfo]="printReportSummeryPeriodInfo"
		id="batterySummaryReport"
	></app-battery-report>
</div>

<div class="white-box main-black p-4 border-radius print-content"
	*ngIf="deviceConfig?.performance?.hasTruckReport">
	<app-truck-report
		[selectedTruckCriteriaPrint]="selectedTruckCriteriaPrint"
		[data]="utilizationScoreTruckData"
		[currentSite]="currentSite"
		[device]="device"
		id="truckSummaryReport"
	></app-truck-report>
</div>

<div class="white-box main-black mt-4 p-4 border-radius" *ngIf="deviceConfig?.performance?.hasBatteryLifeMetics">
	<h1 class="h3 m-4">{{'battlinkDevice.perf_analytic.battery_life_metrics' | translate}}</h1>
	<app-battery-life-metrics *ngIf="isDeviceShipped !== false; else noData" [deviceData]="device"></app-battery-life-metrics>
</div>
<div class="white-box main-black mt-4 p-4 border-radius"
	*ngIf="deviceConfig?.couldHaveStudy && deviceTypeService.isStudyDevice(device.config_info) && !studyInfo.id">
	<app-studies-list parent="device" [device]="device" [currentSite]="currentSite"></app-studies-list>
</div>

<div class="white-box main-black mt-4 p-4 border-radius" *ngIf="deviceType == truckDeviceType && utilizationScoreData && !deviceTypeService.isStudyDevice(device.config_info)">
	<p class="h4">{{'utilization.truck_performance_scores' | translate}}</p>
	<app-truck-summary-report-performance-filters (filters)="getFilters($event)" [resetTrigger]="resetTrigger"></app-truck-summary-report-performance-filters>
	<app-truck-summary-report-performance *ngIf="utilizationScoreData" [tooltipType]="'device'" [data]="utilizationScoreData" [period]="selectedPeriod" [showTooltip]="true" [selectedDays]="selectedDays" [totalTrucks]="1"></app-truck-summary-report-performance>	
</div>

<div class="white-box main-black mt-4 p-4 border-radius" *ngIf="deviceConfig?.performance?.batteryPerformanceScore">
	<h1 class="h3 m-4">{{'battery_performance.battery_performance_scores' | translate}}</h1>
	<app-performance-score-widget *ngIf="isDeviceShipped !== false; else noData" [data]="utilizationScoreData" [devices]="device" [performance]="true" [tooltipType]="'device'" [showTooltip]="true"></app-performance-score-widget> 
</div>

<!-- Battery Daily Usage Report -->
<app-daily-battery-usage-report
	*ngIf="isBattlinkDeviceType(deviceType)"
	[device]="device.config_info"
	[currentSite]="currentSite"
	[hasVoltageFilter]="false"
	[hasCapacityFilter]="false"
	[hasVintageFilter]="false"
	[hasManufacturerFilter]="false"
	[columnsTooltips]="{
		energy_usage_score: 'tooltip.battlinkDevice.daily_energy_usage_score_column',
		battery_ah_return_score: 'tooltip.battlinkDevice.daily_ah_return_score_column'
	}"
></app-daily-battery-usage-report>

<app-batteries-customized-charts
	*ngIf="deviceConfig?.performance?.hasBatteriesCustomizedCharts"
	[minDeviceDate]="deviceInstallationDate"
	[maxDeviceDate]="maxDate"
	[devices]="[device]"
	[siteInfo]="currentSite"
	[siteAlertSettings]="siteAlertSettings"
></app-batteries-customized-charts>

<app-battery-performance *ngIf="deviceConfig?.performance?.hasBatteryPerformance"
	[siteAlertsSettings]="siteAlertSettings" [deviceInfo]="device"></app-battery-performance>

<div
	*ngIf="(deviceConfig?.performance?.has_soc) || (deviceConfig?.couldHaveStudy && deviceTypeService.isStudyDevice(device.config_info) && studyInfo.id)">
	<app-power-study-metrics class="print-content" id="power_study_report" [onPrint]="onPrint" [data]="powerStudyReportData" [selectedPeriodFormatted]="selectedPeriodFormatted" [selectedDays]="selectedDaysPowerStudyReport" [device]="device" [studyInfo]="studyInfo" [siteInfo]="currentSite"></app-power-study-metrics>
</div>

<div class="white-box main-black mt-4 p-4 border-radius" *ngIf="!studyInfo.id && (deviceConfig?.performance?.vpc_charts || deviceConfig?.performance?.has_soc || deviceConfig?.performance?.water_level_chart)">
	<h4 class="mb-4">
		{{'fleet_reports.battery_performance_charts' | translate}}
	</h4>
	<!-- Chart toggles -->
	<div class="chart-toggles-container mt-2 ml-1 mb-3">
		<strong class="mr-3">{{'perf_analytic.select_charts_to_show' | translate}}</strong>

		<div class="chart-toggles-grid">
			<div class="chart-toggle-item" *ngIf="deviceConfig?.performance?.has_soc">
				<mat-slide-toggle [(ngModel)]="showVpcSocChart" name="showVpcSocChart"></mat-slide-toggle>
				<span>{{'perf_analytic.soc_chart_title' | translate}}</span>
			</div>

			<ng-container *ngIf="deviceConfig?.performance?.vpc_charts">
				<div class="chart-toggle-item">
					<mat-slide-toggle [(ngModel)]="showVpcMaxChargeVoltageChart" name="showVpcMaxChargeVoltageChart"></mat-slide-toggle>
					<span>{{'perf_analytic.battery_max_charge_voltage' | translate}}</span>
				</div>

				<div class="chart-toggle-item">
					<mat-slide-toggle [(ngModel)]="showVpcMinInuseVoltageChart" name="showVpcMinInuseVoltageChart"></mat-slide-toggle>
					<span>{{'perf_analytic.battery_min_inuse_voltage' | translate}}</span>
				</div>

				<div class="chart-toggle-item">
					<mat-slide-toggle [(ngModel)]="showVpcEndInuseVoltageChart" name="showVpcEndInuseVoltageChart"></mat-slide-toggle>
					<span>{{'perf_analytic.battery_end_inuse_voltage' | translate}}</span>
				</div>
			</ng-container>

			<div class="chart-toggle-item" *ngIf="deviceConfig?.performance?.water_level_chart && device.config_info.has_water_level">
				<mat-slide-toggle [(ngModel)]="showDailyWaterLevelChart" name="showDailyWaterLevelChart"></mat-slide-toggle>
				<span>{{'perf_analytic.daily_water_level' | translate}}</span>
			</div>
		</div>
	</div>

	<!-- Date filters -->
	<div class="row py-3" *ngIf="showVpcSocChart || showVpcMaxChargeVoltageChart || showVpcMinInuseVoltageChart || showVpcEndInuseVoltageChart || showDailyWaterLevelChart">
		<div class="col-sm-6 col-md-7 d-inline-flex">
			<div class="input-group col-6 p-0 mr-3 d-inline-flex">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.start_date' | translate}}</span>
				</div>
				<input class="form-control" [ngClass]="{'text-danger': vpcInvalidDateRange}" [minDate]="deviceInstallationDate" [maxDate]="vpcMaxDate" placeholder="mm/dd/yyyy" name="vpcStartDB" [(ngModel)]="vpcStartDate" (ngModelChange)="vpcDatesChanged()" bsDatepicker #vpcStartDB="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}"/>
				<div class="input-group-append pointer" (click)="vpcStartDB.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
			<div class="input-group col-6 p-0 mr-3 d-inline-flex">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.end_date' | translate}}</span>
				</div>
				<input class="form-control" placeholder="mm/dd/yyyy" name="vpcEndDB" [(ngModel)]="vpcEndDate" [minDate]="deviceInstallationDate" [maxDate]="vpcMaxDate" (ngModelChange)="vpcDatesChanged()" bsDatepicker #vpcEndDB="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}"/>
				<div class="input-group-append pointer" (click)="vpcEndDB.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>
	</div>

	<!-- Charts -->
	<app-power-study-soc-chart
		*ngIf="showVpcSocChart && deviceConfig?.performance?.has_soc"
		[studyInfo]="studyInfo"
		[minDeviceDate]="deviceInstallationDate"
		[maxDeviceDate]="maxDate"
		[device]="device"
		[socData]="vpcSOCData"
		[tooltipKey]="'battery_soc_chart'"
		[haveZoom]="true"
	></app-power-study-soc-chart>

	<ng-container *ngIf="deviceConfig?.performance?.vpc_charts">
		<app-vpc-charts
			*ngIf="showVpcMaxChargeVoltageChart"
			[data]="vpcMaxChargeVoltage"
			titleKey="perf_analytic.battery_max_charge_voltage"
			seriesLabelKey="perf_analytic.battery_max_charge_voltage"
			tooltipKey="battery_max_charge_voltage_chart"
			[haveZoom]="true"
		></app-vpc-charts>

		<app-vpc-charts
			*ngIf="showVpcMinInuseVoltageChart"
			[data]="vpcMinInuseVoltage"
			titleKey="perf_analytic.battery_min_inuse_voltage"
			seriesLabelKey="perf_analytic.battery_min_inuse_voltage"
			tooltipKey="battery_min_inuse_voltage_chart"
			[haveZoom]="true"
		></app-vpc-charts>

		<app-vpc-charts
			*ngIf="showVpcEndInuseVoltageChart"
			[data]="vpcEndInuseVoltage"
			titleKey="perf_analytic.battery_end_inuse_voltage"
			seriesLabelKey="perf_analytic.battery_end_inuse_voltage"
			tooltipKey="battery_end_inuse_voltage_chart"
			[haveZoom]="true"
		></app-vpc-charts>

		<app-vpc-charts
			*ngIf="showDailyWaterLevelChart && device.config_info.has_water_level"
			[data]="waterLevel"
			titleKey="perf_analytic.daily_water_level"
			seriesLabelKey="perf_analytic.daily_water_level"
			tooltipKey="daily_water_level_chart"
			[haveZoom]="true"
			[valueMappings]="waterLevelValueMappings"
			[vAxisTicks]="waterLevelVAxisTicks"
			[vAxisTitle]="'qv.el_level' | translate"
			[hAxisTitle]="'g.date' | translate"
			dateFormat="YYYY-MM-dd"
		></app-vpc-charts>
	</ng-container>
</div>

<!-- ST-1854 -->
<div *ngIf="0 && deviceConfig?.couldHaveStudy && deviceTypeService.isStudyDevice(device.config_info) && studyInfo.id">
	<app-study-charge-cycle-chart [studyInfo]="studyInfo" [minDeviceDate]="deviceInstallationDate" [maxDeviceDate]="maxDate" 	[device]="device"></app-study-charge-cycle-chart>
</div>

<!-- daily truck usage report -->
<app-daily-truck-usage-report
	*ngIf="deviceType == truckDeviceType && !deviceTypeService.isStudyDevice(device.config_info)"
	[device]="device"
	[currentSite]="currentSite"
	[studyInfo]="studyInfo"
></app-daily-truck-usage-report>

<app-charglink-utilization-report
	*ngIf="chargerDevicesTypes.includes(deviceType)"
	[device]="device"
></app-charglink-utilization-report>

<!-- daily charger usage report -->
<app-charger-usage-data
	*ngIf="chargerDevicesTypes.includes(deviceType)"
	[device]="device"
	[currentSite]="currentSite"
	[studyInfo]="studyInfo"
></app-charger-usage-data>

<!-- monthly quarterly truck usage report -->
<app-monthly-quarterly-truck-usage-report
	*ngIf="deviceType == truckDeviceType && !deviceTypeService.isStudyDevice(device.config_info)"
	[device]="device"
	[studyInfo]="studyInfo"
	[currentSite]="currentSite"
	[isDeviceShipped]="isDeviceShipped"
></app-monthly-quarterly-truck-usage-report>

<!-- monthly quarterly charger usage report -->
<app-charger-monthly-quarterly-usage-report
	*ngIf="chargerDevicesTypes.includes(deviceType)"
	[device]="device"
	[currentSite]="currentSite"
	[studyInfo]="studyInfo"
></app-charger-monthly-quarterly-usage-report>

<app-monthly-daily-truck-usage-chart
	*ngIf="deviceType == truckDeviceType && !deviceTypeService.isStudyDevice(device.config_info)"
	[device]="device"
	[studyInfo]="studyInfo"
	[currentSite]="currentSite"
></app-monthly-daily-truck-usage-chart>

<!-- Daily / Monthly / Quarterly Charger Usage Charts -->
<app-monthly-quarterly-charger-usage-charts
	*ngIf="chargerDevicesTypes.includes(deviceType)"
	[device]="device"
	[currentSite]="currentSite"
	[getMaxKw]="true"
></app-monthly-quarterly-charger-usage-charts>

<app-usage-time-widget
	*ngIf="0 && deviceConfig?.performance?.hasUsageTimeWidget"
	[devices]="[device]"
	[parentPage]="'device'"
	[studyInfo]="studyInfo"
	[minDeviceDate]="deviceInstallationDate"
	[maxDeviceDate]="maxDate"
	tooltipKey="usage_time_device"
></app-usage-time-widget>

<!-- <div *ngIf="!data && !isIMDevice">{{'g.no_data_to_show' | translate}}</div> -->
<div class="white-box main-black mt-4 p-4 border-radius" *ngIf="0 && deviceConfig?.performance?.hasIdleEventsReport">
	<div class="row">
		<div class="col">
			<h4>
				{{'site_performance.idle_events_report' | device_translation:deviceType}}
				<app-help-tooltip *ngIf="tooltips.idle_events_report" [field]="tooltips.idle_events_report"></app-help-tooltip>
			</h4>
		</div>
	</div>
	<div class="row py-4">
		<div class="col-sm-6 col-md-12 col-xl-6 d-inline-flex">
			<div class="input-group col-6 p-0 mr-3 d-inline-flex">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.start_date' | translate}}</span>
				</div>
				<input class="form-control" [ngClass]="{'text-danger': idleTimesInvalidDateRange}" [minDate]="deviceInstallationDate" [maxDate]="maxDate" placeholder="mm/dd/yyyy" name="startDB" [(ngModel)]="idleTimesFromDate" (ngModelChange)="idleTimesDatesChanged()" bsDatepicker #startDB="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}"/>
				<div class="input-group-append pointer" (click)="startDB.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>

			<div class="input-group col-6 p-0 mr-3 d-inline-flex">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.end_date' | translate}}</span>
				</div>
				<input class="form-control" placeholder="mm/dd/yyyy" name="endDB" [(ngModel)]="idleTimesToDate" [minDate]="deviceInstallationDate" [maxDate]="maxDate" (ngModelChange)="idleTimesDatesChanged()" bsDatepicker #endDB="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}"/>
				<div class="input-group-append pointer" (click)="endDB.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>
		</div>
		<div class="col-sm-6 col-md-3 d-inline-flex">
			<div class="input-group">
				<div class="form-check form-check-inline">
					<input class="form-check-input" type="radio" name="idleDataFilter" [(ngModel)]="idleDataFilter" id="inlineRadio1" value="avg" (change)="onSelectionChanged($event.target.value)">
					<label class="form-check-label" for="inlineRadio1">{{'site_performance.avg_truck_hours' | translate}}</label>
				</div>
				<div class="form-check form-check-inline">
					<input class="form-check-input" type="radio" name="idleDataFilter" [(ngModel)]="idleDataFilter" id="inlineRadio2" value="total" (change)="onSelectionChanged($event.target.value)">
					<label class="form-check-label" for="inlineRadio2">{{'site_performance.truck_hours' | translate}}</label>
				</div>
			</div>
		</div>
		<div class="col-sm-6 col-md-1 ml-auto d-inline-flex">
			<button class="btn fa fa-print fa-lg ml-1" printTitle="{{'g.performance' | translate}}" [useExistingCss]="true" printSectionId="idle-chart" ngxPrint title="{{'g.print' | translate}}"></button>
			<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportIdleEvents()"></button>
		</div>
	</div>
	<div id="idle-chart">
		<div class="showOnPrint">
			<h3>{{'devices.truck_sn_short' | translate}}: {{device.config_info.truck_sn}}</h3>
			<h3>{{'devices.serial_number' | translate}}: {{device.serial_number}}</h3>
			<h4>{{'perf_analytic.period' | translate}}: {{idleTimesFromDate | date:'MM/dd/yyyy'}} - {{idleTimesToDate | date:'MM/dd/yyyy'}}</h4>
		</div>
		<ng-container *ngFor="let type of ['avg', 'total']">
			<span>
				<div class="showOnPrint">
					<h4>
						<span class="col-md">
							{{'device_performance.'+type | translate}}
						</span>
					</h4>
				</div>
				<sct-charts
					*ngIf="idleChartData[type] && idleChartData[type].length"
					id="idle_chart_{{idleDataFilter}}"
					[chartId]="'idle_chart_'+idleDataFilter"
					class="showOnPrintToggle"
					[ngClass]="{'invisible': type != idleDataFilter, 'd-none': type != idleDataFilter && chartsReady['idle_chart_'+idleDataFilter]}"
					[title]="'site_performance.idle_events_report' | device_translation:deviceType"
					[data]="idleChartData[type]"
					[columnNames]="idleChartColumnNames"
					[options]="idleTimesOptions"
					[type]="'ColumnChart'"
					[height]="500"
					[formatterType]="'colorFormat'"
					[formatter]="'anything'"
					(ready)="chartReadyFunct($event)"
				></sct-charts>
				<div class="showOnPrint">
					<table class="table">
						<thead>
							<th>{{'g.time' | translate}}</th>
							<th>{{'perf_analytic.value_mins' | translate}}</th>
						</thead>
						<tbody>
							<ng-container *ngFor="let item of idleChartData[type]">
								<tr *ngIf="item[1] != 0">
									<td>{{item[0]}}</td>
									<td>{{item[1] | number:'1.2-2'}}</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</div>
			</span>
		</ng-container>
	</div>
</div>

<!-- Battery Usage Charts -->
<app-daily-monthly-quarterly-battery-usage-charts
	*ngIf="isBattlinkDeviceType(deviceType)"
	[device]="device"
	[currentSite]="currentSite"
	[hasVoltageFilter]="false"
	[hasCapacityFilter]="false"
	[hasVintageFilter]="false"
	[hasManufacturerFilter]="false"
	title="{{'fleet_reports.battery_usage_charts' | translate}}"
></app-daily-monthly-quarterly-battery-usage-charts>

<app-device-end-voltage-charts
	*ngIf="(deviceConfig?.performance?.hasInuseEndVoltageReport || deviceConfig?.performance?.hasChargeEndVoltageReport) && !deviceTypeService.isStudyDevice(device.config_info)"
	[device]="device"
	[currentSite]="currentSite"
	[deviceInstallationDate]="deviceInstallationDate"
	[maxDate]="maxDate"
	[tooltips]="tooltips"
	[deviceType]="deviceType"
	[deviceConfig]="deviceConfig"
	[studyInfo]="studyInfo"
	[isDeviceShipped]="isDeviceShipped"
></app-device-end-voltage-charts>

<app-power-usage-charts
	*ngIf="deviceConfig?.performance?.hasPowerUsageCharts && !deviceTypeService.isStudyDevice(device.config_info)"
	[hasTruckTypesFilter]="false"
	[deviceTypes]="[deviceType]"
	[config]="powerUsageChartConfig"
	[deviceInfo]="this.device.config_info"
	[studyInfo]="studyInfo"
></app-power-usage-charts>

<app-ebu-and-charge-opportunity
	*ngIf="deviceConfig?.performance?.chargeOpportunity && !deviceTypeService.isStudyDevice(device.config_info)"
	[studyInfo]="studyInfo"
	[device]="device"
	[currentSite]="currentSite"
></app-ebu-and-charge-opportunity>

<div class="white-box mt-4 p-4 border-radius" *ngIf="isBattlinkDeviceType(deviceType)">
	<div class="row">
		<div class="col">
			<h4>
				{{'device_performance.battery_realtime_charts' | translate}} <app-help-tooltip [field]="'battlinkDevice.real_time_chart'"></app-help-tooltip>
			</h4>
		</div>
	</div>
	<!-- time filter -->
	<div class="row py-4">
		<div class="row col-10">
			<div class="input-group col-4">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.start_date' | translate}}</span>
				</div>
				<input class="form-control" [ngClass]="{'text-danger': rtInvalidDateRange}" [minDate]="deviceInstallationDate" [maxDate]="rtMaxDate" placeholder="mm/dd/yyyy" name="startRtDB" [(ngModel)]="rtFromDate" (ngModelChange)="rtDatesChanged()" bsDatepicker #startRtDB="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}"/>
				<div class="input-group-append pointer" (click)="startRtDB.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>

			<div class="input-group col-4">
				<div class="input-group-prepend">
					<span class="input-group-text">{{'g.end_date' | translate}}</span>
				</div>
				<input class="form-control" placeholder="mm/dd/yyyy" name="endRtDB" [(ngModel)]="rtToDate" [minDate]="deviceInstallationDate" [maxDate]="rtMaxDate" (ngModelChange)="rtDatesChanged()" bsDatepicker #endRtDB="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}"/>
				<div class="input-group-append pointer" (click)="endRtDB.toggle()">
					<span class="input-group-text"><i class="fa fa-calendar"></i></span>
				</div>
			</div>

			<div class="col-4">
				<ng-select class="select full-width"
					[searchable]="false"
					[clearable]="false"
					[items]="batteryRealTimeVoltageOptions"
					bindLabel="label"
					bindValue="value"
					[placeholder]="'fleet_reports.battery_voltage' | translate"
					[(ngModel)]="selectedBatteryRealTimeVoltageShow"
					(change)="drawRTrecordsChart()"
					>
				</ng-select>
			</div>
		</div>
		<div class="col-1 d-inline-flex ml-auto" *ngIf=" usageChartDataAmp.length && !rtInvalidDateRange && isShippedDevice && showRtChart">
			<button class="btn fa fa-print fa-lg" printTitle="{{'nav.rt_records' | translate}}" [useExistingCss]="true" printSectionId="voltage-and-current-chart" ngxPrint title="{{'g.print' | translate}}"></button>
			<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportRtData()"></button>
		</div>
	</div>

	<!-- charts filter -->
	<div class="row">
		<div class="col-md-12">
			<div class="form-check">
				<input class="form-check-input" type="checkbox" value="" id="defaultCheck1" [(ngModel)]="visibilityCheckboxes.voltage" (change)="drawRTrecordsChart()">
				<label class="form-check-label" for="defaultCheck1">
					{{"fleet_reports.show_voltage" | translate}}
				</label>
			</div>
			<div class="form-check">
				<input class="form-check-input" type="checkbox" value="" id="defaultCheck2" [(ngModel)]="visibilityCheckboxes.current" (change)="drawRTrecordsChart()">
				<label class="form-check-label" for="defaultCheck2">
					{{"fleet_reports.show_current" | translate}}
				</label>
			</div>
		</div>
	</div>

	<!-- charts -->
	<div id="voltage-and-current-chart" class="row" *ngIf="showRtChart; else noData">
		<h2 class="showOnPrint">{{currentSite.customer_name}} / {{currentSite.name}}</h2>
		<h3 class="showOnPrint">{{'nav.rt_records' | translate}}</h3>
		<app-print-filters title="nav.rt_records" [filters]="voltageAndCurrentPrintFilters"></app-print-filters>
		<h4 class="showOnPrint">{{device.mac_address}} ({{device.serial_number}})</h4>
		<sct-charts
			[data]="rtChartObject.data"
			[columnNames]="rtChartObject.columnNames"
			[options]="rtChartObject.config"
			[formatter]="rtChartObject.formatter"
			[formatterType]="rtChartObject.formatterType"
			[title]="'devices.voltage_and_current_chart' | translate"
			[type]="'LineChart'"
			[height]="500"
		></sct-charts>
	</div>

	<!-- temperature chart -->
	<div>
		<div class="col-1 d-flex  ml-auto mt-3" *ngIf=" usageChartDataAmp.length && !rtInvalidDateRange && isShippedDevice && showTempChart">
			<button class="btn fa fa-print fa-lg" printTitle="{{'nav.rt_records' | translate}}" [useExistingCss]="true" printSectionId="temperature-chart" ngxPrint title="{{'g.print' | translate}}"></button>
			<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportRtChartData(tempChartObject?.data, 'rt.temperature')"></button>
		</div>
		<div class="row" *ngIf="showTempChart" id="temperature-chart">
			<h2 class="showOnPrint">{{currentSite.customer_name}} / {{currentSite.name}}</h2>
			<h3 class="showOnPrint">{{'exception_reports.battery_temperature' | translate}}</h3>
			<h4 class="showOnPrint">{{device.mac_address}} ({{device.serial_number}})</h4>
			<app-print-filters title="exception_reports.battery_temperature" [filters]="rtPeriodPrintFilters"></app-print-filters>
			<sct-charts
				[data]="tempChartObject.data"
				[columnNames]="tempChartObject.columnNames"
				[options]="tempChartObject.config"
				[title]="'exception_reports.battery_temperature' | translate"
				[type]="'LineChart'"
				[height]="500">
			</sct-charts>
		</div>
	</div>

	<!-- soc chart -->
	<div>
		<div class="soc-thresholds-container">
			<div class="soc-threshold-item danger">
				<input
					class="soc-threshold-checkbox"
					type="checkbox"
					id="rtSoc20Line"
					[(ngModel)]="show20PercentLine"
					(change)="drawSocChart()"
				>
				<label class="soc-threshold-label" for="rtSoc20Line">
					<span class="soc-threshold-dot"></span>
					{{ 'studies.soc_20' | translate}}
				</label>
			</div>

			<div class="soc-threshold-item success">
				<input
					class="soc-threshold-checkbox"
					type="checkbox"
					id="rtSoc80Line"
					[(ngModel)]="show80PercentLine"
					(change)="drawSocChart()"
				>
				<label class="soc-threshold-label" for="rtSoc80Line">
					<span class="soc-threshold-dot"></span>
					{{ 'studies.soc_80' | translate}}
				</label>
			</div>
		</div>
		<div class="col-1 d-flex  ml-auto mt-3" *ngIf=" usageChartDataAmp.length && !rtInvalidDateRange && isShippedDevice && showSocChart">
			<button class="btn fa fa-print fa-lg" printTitle="{{'nav.rt_records' | translate}}" [useExistingCss]="true" printSectionId="soc-chart" ngxPrint title="{{'g.print' | translate}}"></button>
			<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportRtChartData(socChartObject?.data, 'rt.soc')"></button>
		</div>
		<div class="row" *ngIf="showSocChart" id="soc-chart">
			<h2 class="showOnPrint">{{currentSite.customer_name}} / {{currentSite.name}}</h2>
			<h3 class="showOnPrint">{{'exception_reports.battery_%_soc' | translate}}</h3>
			<h4 class="showOnPrint">{{device.mac_address}} ({{device.serial_number}})</h4>
			<app-print-filters title="exception_reports.battery_%_soc" [filters]="socPrintFilters"></app-print-filters>
			<sct-charts
				[data]="socChartObject.data"
				[columnNames]="socChartObject.columnNames"
				[options]="socChartObject.config"
				[title]="'exception_reports.battery_%_soc' | translate"
				[type]="'LineChart'"
				[height]="500">
			</sct-charts>
		</div>
	</div>
</div>

<!-- For Batt-link devices only add condition-->
<div *ngIf="deviceConfig?.performance?.chargeOpportunity">
	<app-device-alerts [device]="device" [siteAlertsSettings]="siteAlertSettings"></app-device-alerts>
</div>

<ng-template #noData>
	<div class="mt-4 alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>

<app-site-energy-consumption
	*ngIf="deviceConfig?.performance?.hasImUsageDataReport"
	[device]="device"
	[title]="'iotemeter_site_energy_report.meter_energy_consumption' | translate"
	[tooltips]="'meter_energy_consumption'"
></app-site-energy-consumption>

<app-site-energy-report
	*ngIf="deviceConfig?.performance?.hasImUsageDataReport"
	[device]="device"
	[title]="'iotemeter_site_energy_report.monthly_quarterly_meter_usage_report' | translate"
></app-site-energy-report>

<app-energy-consumption-charts
	*ngIf="deviceConfig?.performance?.hasImUsageDataReport"
	[device]="device"
></app-energy-consumption-charts>

<app-im-usage-data
	*ngIf="0 && deviceConfig?.performance?.hasImUsageDataReport"
	[device]="device"
></app-im-usage-data>

<app-im-total-energy-usage
	*ngIf="0 && deviceConfig?.performance?.hasImTotalEnergyUsageReport"
	[device]="device"
></app-im-total-energy-usage>

<app-im-peak-power
	*ngIf="0 && deviceConfig?.performance?.hasImPowerPeakReport"
	[device]="device"
></app-im-peak-power>

<app-power-study-reports
	*ngIf="studyInfo.id && siteUtilizationSettings"
	[siteUtilizationSettings]="siteUtilizationSettings"
	[studyInfo]="studyInfo"
	[device]="device"
	[currentSite]="currentSite"
	[deviceConfig]="deviceConfig"
	[deviceType]="deviceType"
	[tooltips]="tooltips">
</app-power-study-reports>

<ng-template #noData>
	<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>
